<template>
  <v-app>
    <v-progress-linear v-if="$store.state.progressLoading" height="2" indeterminate color="indigo" absolute
      style="top:0px;z-index:1000"></v-progress-linear>
    <div class="bg-design-box bg-design-2"></div>
    <div :class="`bg-design-box bg-design-3 bgcolor-${($route.meta || {}).color}-20`"></div>

    <div v-if="!clientload" class="all-height d-flex align-center justify-center">
      <div>
        <div class="project-title pb-5 text-center">
          <img src="/img/consark/ConsarcLight.svg" class="logo-image" alt="Consarc.ai" />
        </div>
      </div>
    </div>
    <v-layout v-else class="d-flex flex-column">
      <MainNav
        :show-support="true"
        :show-manuals="showManuals"
        :show-injector-dividers="isFinancialCloseRoute"
        :fd-support-widget="fdSupportWidget"
        :support-route="isFinancialCloseRoute ? FC_ROUTES.SUPPORT : null"
        :selected-client-id="selectedclient"
        :applist="applist"
        :clients="$store.state.clientlist"
        :logo-home-route="logoHomeRoute"
        @support-click="openFDSupport"
        @manuals-click="openManuals"
        @logout="logout"
        @edit-profile="editProfileDrawer = true; editProfileSetting = false"
        @client-change="onMainNavClientChange"
        @app-click="onMainNavAppClick"
      >
        <template v-if="isFinancialCloseRoute" #injector>
          <financial-close-top-nav
            :cycle-id="activeFbcCycleId"
            :applist="applist"
            :selected-client-id="selectedclient"
            :chatbot-enabled="chatbotEnabled"
            :can-access-settings="canAccessFinancialCloseMasters"
          />
        </template>
        <template v-else-if="showMainNavInjectorTrailing" #injector>
          <non-fbc-injector-nav
            :show-client-switcher="showMainNavClientSwitcher"
            :show-nav-actions="showNonFbcNavActions"
            :selected-client-id.sync="selectedclient"
            :clients="$store.state.clientlist"
            :chatbot-enabled="chatbotEnabled"
          />
        </template>
      </MainNav>

      <div
        class="d-flex container-scroll shadow-off"
        :class="useFlushSideNavLayout ? 'container-scroll--fbc-shell' : 'app-bar-bg'"
      >
        <SideNav
          v-if="showSideNav"
          :selectedItem.sync="selectedItem"
          :openMenu.sync="openMenu"
          :mini="navminivarient"
          :applist="applist"
          :clientload="clientload"
          :fdSupportWidget="fdSupportWidget"
          :chatbotEnabled="chatbotEnabled"
          :nav-context="fbcNavContext"
          @logout="logout"
          @edit-profile="editProfileDrawer = true; editProfileSetting = false"
          @toggle-mini="toggleNavMini"
        />
        <div
          class="snackbar-container d-flex flex-column"
          :class="{ 'snackbar-container--toast': isFinancialCloseRoute }"
        >
          <ToastStack
            v-if="isFinancialCloseRoute"
            @action="onSnackbarAction"
          />
          <template v-else>
            <v-snackbar bottom dense left
              v-for="(sanckbar, index) in $store.state.snackMultValue.filter((s) => s.showing)"
              :key="sanckbar.id || index" v-model="sanckbar.showing" class="csnackbars pa-0 snackbar" min-height="0"
              min-width="0" elevation="0" :timeout="getSnackbarTimeout(sanckbar)">
              <div class="shadow-on">
                <v-alert border="left" dark :type="sanckbar.type" text class="ma-0 white px-3" dense>
                  <div class="d-flex align-center">
                    <div class="d-flex flex-column justify-center">
                      <span class="body-2 textCapFirst">{{ sanckbar.text }}</span>
                    </div>
                    <v-btn
                      v-if="sanckbar.actionLabel"
                      small
                      text
                      class="ml-3 snackbar-action-btn text-capitalize"
                      :color="sanckbar.type"
                      :data-testid="sanckbar.actionPayload?.testId || 'snackbar__action-btn'"
                      @click="onSnackbarAction(sanckbar)"
                    >
                      {{ sanckbar.actionLabel }}
                    </v-btn>
                    <v-btn icon class="ml-2" :color="sanckbar.type">
                      <v-icon @click="sanckbar.showing = false">mdi-close-circle</v-icon>
                    </v-btn>
                  </div>
                </v-alert>
              </div>
            </v-snackbar>
          </template>
        </div>
        <v-main
          v-resize="onResize"
          :class="[
            'main-layout-main',
            useFlushSideNavLayout ? 'fbc-main-layout' : 'border-radius-main'
          ]"
        >
          <div
            class="all-height"
            :class="{ 'border-radius-main': !useFlushSideNavLayout }"
            style="background-color: #fafafa"
          >
            <div class="main-content-holder">
              <div class="scroller" id="main-route-container">
                <div class="d-flex flex-column all-height">
                  <div class="flex-grow-1  all-height">
                    <!-- Regular page content -->
                    <v-fade-transition>
                      <router-view v-show="!floatingComponentOpen" :key="mainRouterViewKey"
                        class="position-absolute all-width all-height overflow-scroll"></router-view>
                    </v-fade-transition>
                    <!-- Floating Component Full Page View -->
                    <v-fade-transition>
                      <div v-if="floatingComponentOpen"
                        class="floating-component-page position-absolute all-width all-height"
                        :data-testid="`base__${floatingComponentOpen}-page`">
                        <div class="floating-component-content">
                          <chat-bot v-if="floatingComponentOpen === 'chatbot'" />
                          <!-- Future components can be added here -->
                        </div>
                      </div>
                    </v-fade-transition>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-main>
      </div>

      <lb-dialog v-model="EditDetails" heading="My Profile" width="600" persistent>
        <template v-slot:body>

          <div class="d-flex align-center mr-2 mb-3 justify-center">
            <div class="profile-wrapper">
              <v-avatar size="75" class="profile-avatar border-on">
                <v-img v-if="profileImage" :src="profileImage" />
                <v-icon v-else class="placeholder-icon">mdi-account</v-icon>
              </v-avatar>
              <v-btn icon class="upload-icon" @click="triggerFileInput">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </div>
            <input ref="fileInput" type="file" accept="image/*" @change="onImageUpload" class="d-none" />
          </div>

          <v-row>
            <v-col cols="12">
              <v-text-field v-model="userName" label="Name" prepend-icon="mdi-account" required></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="userEmail" readonly label="Email" prepend-icon="mdi-account"
                required></v-text-field>
            </v-col>
            <v-col cols="2" sm="12" class="py-0 d-flex align-center">
              <v-icon class="pr-3">mdi-phone</v-icon>
              <vue-country-code class="" :defaultCountry="CountryCode" style="height: fit-content; border:none"
                @onSelect="getCoutryCode"></vue-country-code>
              <v-text-field v-model="userContact" label="Contact" type="text" required
                @keydown="restrictInput"></v-text-field>
            </v-col>

            <v-col>
              <div style="height:10vh"></div>
            </v-col>
          </v-row>
          <v-col cols="1" sm="12" class="d-flex align-center justify-center">
            <v-spacer></v-spacer>
            <v-btn color="primary" class=" white--text" type="submit"
              @click="updateProfile()"><span>Update</span></v-btn>
            <v-spacer></v-spacer>
          </v-col>
        </template>
      </lb-dialog>

      <lb-drawer v-model="editProfileDrawer" heading="Profile Setting" width="800">
        <template v-slot:body>
          <div class="all-width">
            <div class="d-flex align-center justify-space-between all-width">
              <div class="d-flex align-center justify-start all-width">

                <div class="d-flex align-center mr-2 mb-3 justify-center">
                  <div class="profile-wrapper">
                    <v-avatar size="75" class="profile-avatar">
                      <v-img v-if="profileImage" :src="profileImage" />
                      <v-icon v-else class="placeholder-icon">mdi-account</v-icon>
                    </v-avatar>
                    <v-btn icon class="upload-icon" @click="triggerFileInput">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </div>
                  <input ref="fileInput" type="file" accept="image/*" @change="onImageUpload" class="d-none" />
                </div>


                <div class="d-flex flex-column align-start px-6 justify-start">
                  <p class="ma-0 pa-0 font-size-lg black--text font-weight-bold">{{ $store.state.user.name }}</p>
                  <p class="ma-0 pa-0 grey--text ">{{ $store.state.user.designation }}</p>
                </div>
              </div>
              <v-btn color="white"
                @click="editProfileSetting = true; editProfileDrawer = false"><v-icon>mdi-pencil-outline</v-icon><span>Edit
                  name</span></v-btn>
            </div>
            <v-divider></v-divider>
            <div class="mt-6">

              <v-row class="align-center">
                <v-col cols="3">
                  <p class="pa-0 ma-0">Status</p>
                </v-col>
                <v-col cols="5">
                  <v-menu :close-on-content-click="false" offset-y class="radius-small pa-0"
                    transition="slide-y-transition" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item class="profile pa-0 ma-0 " v-bind="attrs" v-on="on">
                        <div class="border-on d-flex align-center justify-space-between  pa-1 px-2 radius-medium ">
                          <v-icon :color="userStatus.color">{{ userStatus.icon || 'mdi-history' }}</v-icon>
                          <p class="pa-0 ma-0 px-2" :class="`${userStatus.color}--text`">{{ userStatus.name || 'Status'
                            }}</p>
                          <v-icon :color="userStatus.color">mdi-chevron-down</v-icon>
                        </div>
                      </v-list-item>
                    </template>

                    <v-list v-if="!addNewStatus"
                      class="pa-0 ma-0 d-flex flex-column align-start justify-start all-width"
                      style="max-height:100vh; overflow:hidden; width:30vh">
                      <v-list-title class="tableHeaderBg pa-2 all-width">Status</v-list-title>

                      <v-list class="d-flex all-width flex-column align-start px-1"
                        style="max-height:45vh; overflow:scroll">
                        <div class="d-flex align-center py-2 cursor-pointer  radius-small all-width"
                          :class="userStatus.name === item.name ? 'selected-item' : ''"
                          v-for="(item, index) in userStatuslist" :key="index"
                          @click="updateStatus(item.icon, item.name, item.color)">
                          <v-icon class="px-2" :color="userStatus.name === item.name ? 'white' : 'default'">
                            {{ item.icon }}
                          </v-icon>
                          {{ item.name }}
                        </div>
                      </v-list>
                      <v-divider></v-divider>
                      <v-list class="d-flex align-center px-1 all-width justify-space-between">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="addNewStatus = true; newstatusname = ''"
                          class="white--text px-1 font-size-xm"><span>Add new status</span></v-btn>
                      </v-list>

                    </v-list>

                    <v-list v-else class="pa-0 ma-0  d-flex flex-column align-start justify-start all-width">
                      <v-list-title class="d-flex align-center tableHeaderBg justify-start all-width">
                        <v-btn icon @click="addNewStatus = false">
                          <v-icon>mdi-keyboard-backspace</v-icon>
                        </v-btn>
                        <p class="pa-0 ma-0">Create new status</p>
                      </v-list-title>
                      <v-divider></v-divider>
                      <v-list-item class="my-2">
                        <p class="pa-1 ma-0  border-on radius-small mr-2">
                          <v-icon size="30" style="font-size:2.2rem !important">mdi-emoticon-happy-outline</v-icon>
                        </p>
                        <lb-string v-model="newstatusname" label="" :hidedetails="true"
                          placeholder="Enter new status"></lb-string>
                      </v-list-item>
                      <v-list-item class="d-flex align-center all-width justify-space-between">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click.stop="addNewStatustolist"
                          class="white--text px-1 font-size-xm"><span>Add
                            status</span></v-btn>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>


              <v-row>

                <v-col cols="3">
                  <p class="pa-0 ma-0">Email ID</p>
                </v-col>
                <v-col cols="5">
                  <p class="pa-0 ma-0">{{ profileEmail }}</p>

                </v-col>
              </v-row>

              <v-row>

                <v-col cols="3">
                  <p class="pa-0 ma-0">Mobile number</p>
                </v-col>
                <v-col cols="5">
                  <p class="pa-0 ma-0">{{ $store.state.user.contactno }}</p>
                </v-col>
                <v-col cols="4" class="pa-1 d-flex justify-end align-center">
                  <v-btn color="white" class="font-size-xm"
                    @click="editProfileSetting = true; editProfileDrawer = false"><v-icon>mdi-pencil-outline</v-icon><span>Edit
                      number</span></v-btn>
                </v-col>
              </v-row>

            </div>
          </div>
        </template>
        <template v-slot:actions>
          <div class="d-flex align-center justify-end all-width">
            <v-btn class="secondaryBtn radius-small mx-2"><span>Request to change email</span></v-btn>
            <v-btn color="primary" @click="logout" link><span>Logout</span></v-btn>
          </div>
        </template>
      </lb-drawer>

      <lb-drawer v-model="editProfileSetting" heading="Profile Setting" width="800">
        <template v-slot:body>
          <div class="all-width">
            <div class="d-flex align-center justify-space-between all-width">
              <div class="d-flex align-center justify-start all-width">

                <div class="d-flex align-center mr-2 mb-3 justify-center">
                  <div class="profile-wrapper">
                    <v-avatar size="75" class="profile-avatar">
                      <v-img v-if="profileImage" :src="profileImage" />
                      <v-icon v-else class="placeholder-icon">mdi-account</v-icon>
                    </v-avatar>

                  </div>
                </div>
                <div class="d-flex flex-column align-start px-4 justify-start">
                  <lb-string label="" hidedetails :clearable="false" placeholder="Name" v-model="userName" />
                  <lb-string label="" class="my-2" placeholder="Designation" hidedetails :clearable="false"
                    v-model="userDesgination" />
                </div>
              </div>
              <v-btn color="caccounting" class="white--text" @click="updateProfile()"><span>Done</span></v-btn>
            </div>
            <v-divider></v-divider>
            <div class="mt-6">

              <v-row class="align-center">
                <v-col cols="3">
                  <p class="pa-0 ma-0">Status</p>
                </v-col>
                <v-col cols="5">
                  <v-menu :close-on-content-click="false" offset-y class="radius-small pa-0"
                    transition="slide-y-transition" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item class="pa-0 ma-0 " v-bind="attrs" v-on="on">
                        <div class="border-on d-flex align-center justify-space-between  pa-1 px-2 radius-medium ">
                          <v-icon :color="userStatus.color">{{ userStatus.icon || 'mdi-history' }}</v-icon>
                          <p class="pa-0 ma-0 px-2" :class="`${userStatus.color}--text`">{{ userStatus.name || 'Status'
                            }}</p>
                          <v-icon :color="userStatus.color">mdi-chevron-down</v-icon>
                        </div>
                      </v-list-item>
                    </template>

                    <v-list v-if="!addNewStatus"
                      class="profile pa-0 ma-0 d-flex flex-column align-start justify-start all-width"
                      style="max-height:50vh; overflow:hidden; width:30vh">
                      <v-list-title class="tableHeaderBg pa-2 all-width">Status</v-list-title>

                      <v-list-item class="d-flex all-width flex-column align-start px-1"
                        style="max-height:45vh; overflow:scroll">
                        <div class="d-flex align-center justify-start py-2 cursor-pointer  radius-small all-width"
                          v-for="(item, index) in userStatuslist" :key="index"
                          @click="updateStatus(item.icon, item.name, item.color)"
                          :class="userStatus.name === item.name ? 'selected-item' : ''">
                          <v-icon class="px-2" :color="userStatus.name === item.name ? 'white' : 'default'">
                            {{ item.icon }}
                          </v-icon>
                          {{ item.name }}
                        </div>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item class="d-flex align-center all-width justify-space-between">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="addNewStatus = true; newstatusname = ''"
                          class="white--text px-1 font-size-xm"><span>Add new status</span></v-btn>
                      </v-list-item>

                    </v-list>

                    <v-list v-else class="pa-0 ma-0  d-flex flex-column align-start justify-start all-width">
                      <v-list-title class="d-flex align-center tableHeaderBg justify-start all-width">
                        <v-btn icon @click="addNewStatus = false">
                          <v-icon>mdi-keyboard-backspace</v-icon>
                        </v-btn>
                        <p class="pa-0 ma-0">Create new status</p>
                      </v-list-title>
                      <v-divider></v-divider>
                      <v-list-item class="my-2">
                        <p class="pa-1 ma-0  border-on radius-small mr-2">
                          <v-icon size="30" style="font-size:2.2rem !important">mdi-emoticon-happy-outline</v-icon>
                        </p>
                        <lb-string v-model="newstatusname" label="" :hidedetails="true"
                          placeholder="Enter new status"></lb-string>
                      </v-list-item>
                      <v-list-item class="d-flex align-center all-width justify-space-between">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click.stop="addNewStatustolist"
                          class="white--text px-1 font-size-xm"><span>Add
                            status</span></v-btn>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <p class="pa-0 ma-0">Email ID</p>
                </v-col>
                <v-col cols="5">
                  <p class="pa-0 ma-0">{{ profileEmail }}</p>

                </v-col>
              </v-row>
              <v-row class="align-center justify-start d-flex">
                <v-col cols="3">
                  <p class="pa-0 ma-0">Mobile number</p>
                </v-col>
                <v-col cols="5">
                  <lb-string label="" :hidedetails=true :clearable="false" v-model="userContact"></lb-string>
                </v-col>
                <v-col cols="4" class="pa-1 d-flex justify-end align-center">
                  <v-btn color="caccounting" class="white--text" @click="updateProfile()"><span>Done</span></v-btn>
                </v-col>
              </v-row>
            </div>
          </div>
        </template>
        <template v-slot:actions>
          <div class="d-flex align-center justify-end all-width">
            <v-btn class="secondaryBtn radius-small mx-2"><span>Request to change email</span></v-btn>
            <v-btn color="primary" @click="logout" link><span>Logout</span></v-btn>
          </div>
        </template>
      </lb-drawer>
    </v-layout>
  </v-app>
</template>

<script>
import SideNav from '@/components/SideNav.vue';
import MainNav from '@/components/navigation/MainNav/MainNav.vue';
import FinancialCloseTopNav from '@/components/navigation/FinancialClose/FinancialCloseTopNav.vue';
import NonFbcInjectorNav from '@/components/navigation/MainNav/NonFbcInjectorNav.vue';
import ChatBot from '@/modules/chatbot/views/ChatBot.vue';
import ToastStack from '@/views/common/Toast/ToastStack.vue';
import {
  extractCycleIdFromPath,
  extractCycleIdFromRoute,
  isFbcCycleRoute,
  resolveFbcNavContext
} from '@/components/navigation/FinancialClose/financialCloseTopNavUtils';
import { extractChatbotContextFromRoute } from '@/modules/chatbot/utils';
import { isAppSwitcherManagerUser, isPbcRequesteeRoute } from '@/components/navigation/MainNav/mainNavUtils';
import {
  getInitialClientId,
  getTentativeClientId,
  hrefMatchesCurrent,
  isClientInList,
  normalizeRoutePath,
} from '@/plugins/clientId';
const { default: constants } = require('../plugins/constants');
const { FC_ROUTES, FC_UNDEFINED_ID_PATTERN } = require('../modules/financialclose/utils/constants');
const { writeCycleListLiteHandoff } = require('../modules/financialclose/utils/selectLandingCycle');
const { isAccrualsSurfacePath } = require('../modules/financialclose/utils/accrualsFeatureFlag');
const { openTaskDetailPage } = require('../modules/financialclose/utils/tasklistUtils');

export default {
  name: "app",
  data: () => ({
    group: null,
    login: false,
    showNavgation: true,
    navminivarient: true, // Always collapsed (mini) by default
    showHeaderAction: true,
    containerHeight: 0,
    clientload: false,
    profileDetailsReady: false,
    downloaddialog: false,
    activemenu: 0,
    reloadkey: 0,
    display: "load",
    loading: 0,
    clientSwitchRequestId: 0,
    routeid: "",
    applist: [
    ],
    appname: "",
    selectedclient: "",
    pathName: "",
    isPlanExpaired: false,
    newMenuList: [],
    admins: [
      ['Management', 'mdi-account-multiple-outline'],
      ['Settings', 'mdi-cog-outline'],
    ],
    editProfileDrawer: false,
    FC_ROUTES,
    userStatuslist: [
      {
        icon: "mdi-check-circle",
        name: "Available",
        color: 'success'
      },
      {
        icon: "mdi-calendar-blank",
        name: " In a meeting",
        color: 'info'
      },
      {
        icon: "mdi-minus-circle-outline",
        name: "Do not disturb",
        color: 'error'
      },
      {
        icon: "mdi-close-circle-outline",
        name: "Appear Away",
        color: 'primary'
      },
    ],
    userStatus: {},
    newstatusname: "",
    addNewStatus: false,
    profileImage: null,
    profileImageError: false,
    profileImageMenuError: false,
    editProfileSetting: false,
    userName: "",
    userContact: "",
    userDesgination: "",
    EditDetails: false,
    userEmail: '',
    CountryCode: '',
    selectedItem: null,
    openMenu: false,
    timerId: null,
    logoImageError: false,
    fdSupportWidget: process.env?.VUE_APP_FD_SUPPORT_WIDGET === "true" || process.env?.VUE_APP_FD_SUPPORT_WIDGET === true,
    chatWidgetInView: false,
    floatingComponentOpen: null, // null | 'chatbot' | future component names
  }),
  components: {
    SideNav,
    MainNav,
    FinancialCloseTopNav,
    NonFbcInjectorNav,
    ChatBot,
    ToastStack,
  },
  created() {
    // this.$store.dispatch('fetchCycleList');
    // Always collapsed (mini) by default, do not override from localStorage or store
    // Force mini/collapsed by default, do not read from localStorage or store
    this.navminivarient = true;
    this.syncProfileFormFromStore();
    const existingStatus = this.userStatuslist.find(
      status => status.name === this.$store.state.user.activestatus
    );
    if (existingStatus) {
      this.userStatus = { icon: existingStatus.icon, name: existingStatus.name, color: existingStatus.color };
    } else {
      let newstatus = {
        icon: "mdi-emoticon-happy-outline",
        name: this.$store.state.user.activestatus,
        color: 'caccounting'
      };
      this.userStatuslist.push(newstatus);
      this.userStatus = { icon: newstatus.icon, name: newstatus.name, color: newstatus.color };
    }

    // this.setMenu(this.$route.path);
    if (this.isAdminConsolePath()) {
      this.clientload = true;
    }
    this.getDetails();
  },
  mounted() {
    // Attach openFDSupport to root instance for child components
    this.$root.openFDSupport = this.openFDSupport;
    // Attach floating component methods to root instance for child components
    this.$root.openFloatingComponent = this.openFloatingComponent;
    this.$root.toggleChatbot = this.toggleChatbot;
    this.$root.closeChatbot = this.closeChatbot;
    this.$root.closeFloatingComponent = this.closeFloatingComponent;
    this.$root.closeFloatingComponents = this.closeFloatingComponents;

    this.initSelectedClientFromRoute();
    this.dragFunctions();
    this.onResize();
    document.body.classList.toggle('nav-mini', this.navminivarient);
    document.body.classList.toggle('nav-full', !this.navminivarient);
    // ----------------
    // TODO - use this in the future if authentication is needed for Freshdesk widget
    // To enable authenticated widget experience, generate a JWT and call:
    // this.$freshworks.authenticate(token);
    // See: https://developers.freshdesk.com/widget-api/
    // ----------------
  },
  beforeUnmount() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
    document.body.classList.remove('fbc-main-nav');
  },
  methods: {
    toggleNavMini() {
      // Toggle the nav state AND persist to store so watchers & other components stay in sync
      this.navminivarient = !this.navminivarient;
      this.$store.commit('toogleNavBar', this.navminivarient);
    },
    onSnackbarAction(snackbar) {
      const payload = snackbar?.actionPayload;
      if (!payload) return;

      if (payload.type === 'view-task' && payload.task) {
        openTaskDetailPage({
          router: this.$router,
          store: this.$store,
          task: payload.task,
          checklistId: payload.checklistId,
          userType: payload.userType,
          tasklistView: payload.tasklistView,
        });
      }

      snackbar.showing = false;
    },
    getSnackbarTimeout(snackbar) {
      const duration = Number(snackbar?.time);
      return duration > 0
        ? duration
        : constants.SNACKBAR.DEFAULT_DURATION_MS;
    },
    onImageUpload(event) {
      const file = event.target.files[0];
      this.updateProfile(file)
      if (file) {
        this.profileImage = URL.createObjectURL(file);
      }
    },
    restrictInput(event) {
      const key = event.key;
      if (!/^[0-9]$/.test(key) && !['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(key)) {
        event.preventDefault();
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    getCoutryCode({ iso2 }) {
      this.userDetails.countrycode = iso2
    },
    updateStatus(icon, name, color) {
      this.userStatus = { icon, name, color };
      this.updateProfile()
    },
    addNewStatustolist() {
      let newstatus = {
        icon: "mdi-emoticon-happy-outline",
        name: this.newstatusname,
        color: 'caccounting'
      };
      if (!this.userStatuslist.includes(newstatus)) {
        this.userStatuslist.push(newstatus);
      }
      this.updateStatus(newstatus.icon, newstatus.name);
      this.addNewStatus = false
    },
    changeNavVarient(flag) {
      this.$store.commit('toogleNavBar', flag);
    },
    /**
     * Post-login bootstrap for authenticated sessions: loads profile, clients,
     * subscriptions, and permissions, builds the app nav list, then handles
     * initial redirects (e.g. FC landing). Skipped when noauth; hydrates
     * requestee context instead.
     */
    getDetails(options = {}) {
      if (!this.$store.state.noauth) {
        let didAddLoading = false;
        this.$store.commit("addLoading");
        didAddLoading = true;
        this.loading++;
        let pcodes = [];
        let rdata = {};
        const { PRODUCT_KEYS, PLAN_FREE, ROUTE_PATHS, API_URLS, STORAGE_KEYS, STORE_MODULE_PREFIX, APP_REGISTRY } = constants;
        // Bind the switched org before getdetails so subscription/applist
        // are not built from the first client on a cold reload.
        let persistedClientId = '';
        try {
          persistedClientId = localStorage.getItem(STORAGE_KEYS.ENTITY) || '';
        } catch (_) { /* storage unavailable */ }
        const tentativeClientId = getTentativeClientId({
          preferClientId: options.preferClientId,
          routeClientId: this.$route.query.cid,
          storeClientId: this.$store.state.client || this.$store.state.auth?.boundClient,
          persistedClientId,
        });
        if (tentativeClientId) {
          this.$store.commit('setClient', tentativeClientId);
          this.$store.commit('auth/setBoundClient', tentativeClientId);
        }
        const profilePayload = tentativeClientId ? { client: tentativeClientId } : {};
        this.axios.post(API_URLS.PROFILE_GET_DETAILS, profilePayload).then(dt => {

          if (dt.data.status === "success") {
            rdata = (dt.data.data || [])[0] || {};
            let clientdata = rdata.clients || [];
            this.$store.commit("setClientList", clientdata);
            this.$store.commit("refreshClient", false);
            if (clientdata.length > 0) {
              const preferred = options.preferClientId;
              const selected = (preferred && isClientInList(preferred, clientdata))
                ? String(preferred)
                : getInitialClientId(
                  clientdata,
                  this.$route,
                  persistedClientId,
                );
              if (selected) {
                this.$store.commit('setClient', selected);
                this.$store.commit('auth/setBoundClient', selected);
                this.$store.commit(
                  'setClientDetails',
                  clientdata.find((c) => String(c._id) === String(selected)) || {},
                );
                this.selectedclient = selected;
                try {
                  localStorage.setItem(STORAGE_KEYS.ENTITY, selected);
                } catch (_) { /* storage unavailable */ }
                // getlocation needs the selected org on the body; run after setClient,
                // in parallel with AUTH_GET_PERMISSION below.
                this.getLocationHeader();
                this.fetchLabelsData();
              }
            }
            let subsdata = rdata.subscription || {};
            // Check for Free plan expiry on products that support it
            const expiryProducts = [PRODUCT_KEYS.FINANCIAL_CLOSE, PRODUCT_KEYS.VARIANCE_ANALYSIS];
            for (const productSub in subsdata) {
              if (expiryProducts.includes(productSub)) {
                const data = subsdata[productSub];
                if (data.plan_detail.name === PLAN_FREE) {
                  this.isPlanExpaired = data.plan_detail.expiry || false;
                  if (this.isPlanExpaired) {
                    const storeKey = STORE_MODULE_PREFIX + productSub;
                    if (this.$store.state[storeKey]) {
                      this.$store.state[storeKey].menu = [];
                    }
                  }
                }
              }
            }
            if (Object.keys(subsdata).length <= 2) {
              let redirectlink = "";
              let redirectflag = true;
              let redirectIsFC = false;
              for (const k in subsdata) {
                if (Object.hasOwnProperty.call(subsdata, k)) {
                  if (k !== PRODUCT_KEYS.ADMIN) {
                    const el = subsdata[k];
                    if (redirectlink === "") {
                      redirectlink = el?.product_detail?.homepage || "";
                      redirectIsFC = (k === PRODUCT_KEYS.FINANCIAL_CLOSE);
                    }
                    else redirectflag = false
                  }
                }
              }
              if (redirectflag && !this.isAdminConsolePath()) {
                if (redirectIsFC) {
                  // Stay on the current cycle after re-login; only auto-land on recent cycle from generic entry points.
                  if (!this.isOnValidFcCycleRoute()) {
                    this.navigateToFCLanding();
                  }
                } else {
                  const targetPath = (redirectlink || '').split('?')[0];
                  if (!targetPath || !this.$route.path.startsWith(targetPath)) {
                    this.$nova.gotoLink({ path: redirectlink });
                  }
                }
              }
            }
            this.$store.commit("setSubscription", subsdata);

            for (const k in subsdata) {
              if (Object.hasOwnProperty.call(subsdata, k)) {
                const el = subsdata[k];
                pcodes.push(el.product_detail.code);
              }
            }
            return this.axios.post(API_URLS.AUTH_GET_PERMISSION, {});
          } else {
            this.$store.commit("sbError", "Error fetching client list");
          }
        }).then(dt => {
          if (dt.data.status === "success") {
            if (dt.data.data.length > 0) {
              this.$store.commit("setPermission", dt.data.data[0]);
              const perm = dt.data.data[0];
              this.applist = [];
              for (const entry of APP_REGISTRY) {
                // Check if any of the entry's product codes are in the subscribed list
                const hasCode = entry.codes.some(code => pcodes.includes(code));
                if (!hasCode) continue;
                // Check permission if required
                if (entry.permissionKey) {
                  // For TDS: permission only required for specific codes (tds_monthly)
                  if (entry.permissionOnlyCodes) {
                    const needsPermCheck = entry.permissionOnlyCodes.some(c => pcodes.includes(c));
                    const otherCodesPresent = entry.codes.filter(c => !entry.permissionOnlyCodes.includes(c)).some(c => pcodes.includes(c));
                    if (!otherCodesPresent && needsPermCheck && !perm[entry.permissionKey]) continue;
                  } else {
                    if (!perm[entry.permissionKey]) continue;
                  }
                }
                const displayname = entry.useBotName ? constants.BOT_NAME + 's' : entry.displayname;
                this.applist.push({ name: entry.name, displayname, color: entry.color, avatartext: entry.avatartext, logo: "", icon: "", link: entry.link });
              }
            }
          } else throw Error("Error fetching permission details");
        }).then(() => {
          console.log("six month");
          this.scheduleLabelsApiCall();
        }).catch(err => {
          this.$store.commit("sbError", err.message || "Unknown error!");
          console.log(err);
        }).finally(async () => {
          this.onResize();
          this.reloadkey += 1;
          this.profileDetailsReady = true;
          try {
            await this.checkSubscriptionPermission(this.$route, this.$route);
          } catch (err) {
            console.error('[base.vue]: checkSubscriptionPermission error', err);
          }
          // Handle redirects BEFORE decrementing loading so the loader
          // stays visible while FC cycle data is being fetched.
          // Keep clientload false until org is known and post-login routing
          // is done so FC child views cannot mount and fetch without client.
          if (this.$route.path === ROUTE_PATHS.ROOT) {
            const restoredPostLoginRoute = this.restorePostLoginRoute();
            if (!restoredPostLoginRoute && this.applist.find((item) => item.name === PRODUCT_KEYS.FINANCIAL_CLOSE)) {
              console.log("Redirecting to FC landing page as it's the only product available");
              const cycle = await this.fetchFCLandingCycle();
              this.navigateToFCRoute(cycle);
            } else if (!restoredPostLoginRoute && this.applist.find((item) => item.name === PRODUCT_KEYS.VARIANCE_ANALYSIS)) {
              this.$nova.gotoLink({ path: ROUTE_PATHS.VA_ACTUAL_ANALYSIS });
            } else if (!restoredPostLoginRoute) {
              this.$nova.gotoLink({ path: this.applist?.[0]?.link });
            }
          }
          // Handle undefined project ID in current route
          await this.handleUndefinedProjectId();
          this.hydrateFcCycleFromRoute();
          this.clientload = true;
          this.loading--;
          if (didAddLoading) {
            this.$store.commit("removeLoading");
          }
          // Drop leftover boot splash if it is still counted.
          if (this.$store.state.loading > 0) {
            this.$store.commit("removeLoading");
          }
        });
      } else {
        this.reloadkey += 1;
        this.profileDetailsReady = true;
        this.clientload = true;
        this.hydrateRequesteeNavContext();
        if (this.$store.state.loading > 0) {
          this.$store.commit('removeLoading');
        }
      }
    },
    resolveBoundClientId() {
      const rawClient =
        this.$store.state.client ||
        this.$store.state.auth?.boundClient ||
        this.$store.state.user?.client ||
        '';
      if (rawClient && typeof rawClient === 'object') {
        return rawClient._id || rawClient.id || '';
      }
      return rawClient;
    },

    fetchLabelsData() {
      this.$store.dispatch('fetchLabels');
    },

    scheduleLabelsApiCall() {
      const client = this.resolveBoundClientId();
      const labelsClient = this.$store.state.labelsClient;
      const tenantChanged = Boolean(client)
        && Boolean(labelsClient)
        && String(labelsClient) !== String(client);
      const storedTimestamp = localStorage.getItem(constants.STORAGE_KEYS.LAST_LOGIN_TIME);
      const lastLoginTime = storedTimestamp ? parseInt(storedTimestamp, 10) : 0;
      const currentTime = Date.now();
      const timeElapsed = currentTime - lastLoginTime;
      const oneDayMs = 24 * 60 * 60 * 1000;

      if (tenantChanged || !lastLoginTime || isNaN(lastLoginTime) || timeElapsed >= oneDayMs) {
        this.fetchLabelsData();
      } else {
        const timeRemaining = oneDayMs - timeElapsed;
        this.timerId = setTimeout(() => this.fetchLabelsData(), timeRemaining);
      }
    },

    logout() {
      const finishLocalLogout = () => {
        try {
          this.$tokenUtils.removeSecureToken();
        } catch (_) { /* storage unavailable */ }
        this.$store.dispatch('auth/clearSession');
        this.$store.commit('resetUser');
        this.$router.push('/');
      };

      this.axios.post(constants.API_URLS.AUTH_LOGOUT, {
      }).then(x => {
        console.info({
          message: 'Logout',
          meta: { success: x.data.status == "success" },
        });
        finishLocalLogout();
      }).catch(e => {
        console.warn({
          message: 'Logout',
          statusCode: e?.response?.status,
          meta: { success: false },
        });
        // Clear local state even if logout API fails (e.g. already expired)
        finishLocalLogout();
        this.$store.commit("sbError", e.message || "Logout error!");
      })
    },
    openManuals() {
      constants.rememberManualsReturnPath(this.$route.path);
      this.$nova.gotoLink({
        path: constants.ROUTE_PATHS.MANUALS,
        query: this.selectedclient ? { cid: this.selectedclient } : undefined,
      });
    },
    setMenu(path) {
      const menuPath = constants.menuContextPath(path);
      this.appname = constants.STORE_MODULE_PREFIX + (menuPath || "").split("/")[1] || "";
      // console.log( this.appname,"FFF");
      let menuitems = [];
      let storeobj = this.$store.state[this.appname] || {};
      if (storeobj.menu) {
        if (this.$store.state.newmenu.length > 0) menuitems = [...this.$store.state.newmenu, ...this.$store.state.custommenu];
        else menuitems = [...this.$store.state[this.appname]?.menu, ...this.$store.state.custommenu];
      }
      else menuitems = [];
      let newmenu = [];
      let dummymenu = [];
      let headerstart = false;
      let menupostsubs = [];
      let addcust = this.$route.meta?.submenu || [];
      let params = this.$route.params;
      // console.log(this.$route);
      for (const i of menuitems) {
        if (i.submenu && addcust.indexOf(i.variable) > -1) {
          if (storeobj[i.variable]) {
            let nm = [];
            // console.log("in1111")
            for (const j of storeobj[i.variable]) {
              if (j.href) {
                let nj = { ...j };
                // console.log("in1122", nj.href);
                let replacetexts = nj.href.match(/\${2}\w+[^_]\${2}/g) || [];
                for (const k of replacetexts) {
                  let ttext = k.replaceAll("$", "");
                  // console.log("in2222", k, params[ttext]);
                  if (params[ttext]) nj.href = nj.href.replaceAll(k, params[ttext]);
                  // console.log("post replace", nj.href);
                }
                nm.push(nj)
              } else nm.push(j);
            }
            menupostsubs = [...menupostsubs, ...nm]
          }
        } else menupostsubs.push(i);
      }
      for (const i of menupostsubs) {
        if (i.product) newmenu.push(i);
        else if (i.header) {
          if (headerstart) {
            if (dummymenu.length > 1) newmenu = [...newmenu, ...dummymenu];
            dummymenu = [];
          }
          dummymenu.push(i);
          headerstart = true;
        } else {
          if ((i.href === constants.ROUTE_PATHS.VA_QUEUE || i.label_id === 'commentary_queue_management_label_menu') && !this.$store.getters.isQueueEnabled) {
            continue;
          }
          // Skip items hidden for super admin (check actual permission, not store flag)
          if (i.hideForSuperAdmin && this.$nova.hasRight('commentary', ['superadmin'])) {
            continue;
          }
          if (this.$nova.hasRight(i.right, i.action)) {
            if (headerstart) dummymenu.push(i);
            else newmenu.push(i);
          }
        }
      }
      if (dummymenu.length > 1) newmenu = [...newmenu, ...dummymenu];
      newmenu.map((menuitem) => {
        if (menuitem.label_id) {
          menuitem.title = this.$nova.labelsName('cycle_page', menuitem.label_id, menuitem.title)
        }
        return menuitem;
      })
      this.$store.commit("setMenu", newmenu);
    },
    setCustomMenu() {
    },
    onResize() {
      setTimeout(() => {
        // Previously we forcibly collapsed the nav (mini) on < lg breakpoints.
        // That prevented users from expanding it at widths like 1024px (md/lg boundary on some devices).
        // We now allow manual expansion even on smaller screens. If you want an auto-collapse ONLY when
        // entering really (e.g., xs) widths, implement a conditional here (e.g., if (this.$vuetify.breakpoint.xs)).
      }, 500);
      if (this.$refs.toolbar && document.getElementById("main")) {
        this.$store.commit("setHeight", (((document.getElementById("main").offsetHeight) - (this.$refs.toolbar.$el.offsetHeight || 0) - 2) || '100vh'));
      }
    },
    getExtImage: function (n) {
      let na = n.split(".");
      let ext = na[na.length - 1];
      if (ext === "pptx") return "/img/tpa_icons/ppt.jpg";
      else if (ext === "xlsx") return "/img/tpa_icons/excel.jpg";
      else if (ext === "zip") return "/img/tpa_icons/zip.jpg";
      else return "";
    },
    dragFunctions() {
      document.addEventListener('dragstart', event => {
        event.target.style.opacity = 0.5;
      });
      document.addEventListener('dragend', event => {
        event.target.style.opacity = 1;
      });
    },
    // ─── Financial Close helpers ────────────────────────────────────
    // All FC-specific navigation, route-param handling, cycle info
    // fetching, and client-switch logic lives in this section.
    // Other FC-aware code (getDetails, checkSubscriptionPermission)
    // stays inline because those methods handle multiple products.
    // ─────────────────────────────────────────────────────────────────

    isOnValidFcCycleRoute(route = this.$route) {
      const cycleId = extractCycleIdFromRoute(route);
      if (!cycleId || cycleId === 'undefined') return false;
      return isFbcCycleRoute(route?.path || '');
    },
    restorePostLoginRoute() {
      const { ROUTE_PATHS, STORAGE_KEYS } = constants;
      let raw = null;
      try {
        raw = sessionStorage.getItem(STORAGE_KEYS.POST_LOGIN_RETURN_PATH);
        if (raw) {
          sessionStorage.removeItem(STORAGE_KEYS.POST_LOGIN_RETURN_PATH);
        }
      } catch (_) { /* storage unavailable */ }
      if (!raw || raw === ROUTE_PATHS.ROOT) return false;

      const queryIndex = raw.indexOf('?');
      const path = queryIndex >= 0 ? raw.slice(0, queryIndex) : raw;
      const search = queryIndex >= 0 ? raw.slice(queryIndex + 1) : '';
      const query = {};
      if (search) {
        new URLSearchParams(search).forEach((value, key) => {
          query[key] = value;
        });
      }
      if (!path || path === ROUTE_PATHS.ROOT) return false;

      console.log('[base.vue]: restoring post-login route', raw);
      this.$nova.gotoLink({ path, query });
      return true;
    },
    /**
     * Fetch the most recent open cycle for the current client.
     * Returns the cycle object if found, or null.
     */
    async fetchFCLandingCycle() {
      if (!this.$store.state.client) return null;
      try {
        const cycle = await this.$store.dispatch('project/fetchMostRecentOpenCycle');
        console.log('[base.vue]: fetchFCLandingCycle response', cycle);
        return (cycle && cycle._id) ? cycle : null;
      } catch (err) {
        console.error('[base.vue]: fetchFCLandingCycle error', err);
        return null;
      }
    },
    /**
     * Navigate to a FC cycle's checklist, or fall back to /financialclose/home.
     * Pure navigation — no async work.
     */
    navigateToFCRoute(cycle) {
      const cid = this.$store.state.client;
      if (cycle && cycle._id) {
        this.$store.commit('addItemToCycleList', cycle);
        this.$nova.gotoLink({ path: FC_ROUTES.CHECKLIST(cycle._id), query: { cid } });
      } else {
        this.$nova.gotoLink({ path: FC_ROUTES.HOME, query: { cid } });
      }
    },
    /**
     * Convenience: fetch cycle + navigate in one call.
     */
    async navigateToFCLanding() {
      const cycle = await this.fetchFCLandingCycle();
      this.navigateToFCRoute(cycle);
    },
    /**
     * Detect and handle routes with 'undefined' as the project ID.
     */
    async handleUndefinedProjectId() {
      const path = this.$route.path || '';
      if (!path.includes(constants.PRODUCT_KEYS.FINANCIAL_CLOSE)) return;
      if (!FC_UNDEFINED_ID_PATTERN.test(path)) return;
      console.log(`[base.vue]: Detected route with undefined project ID: ${path}, redirecting to FC landing`);
      await this.navigateToFCLanding();
    },
    /**
     * Called by the $route.params.id and $route.params.projectId watchers.
     * Validates the cycle ID and fetches cycle info, or redirects to FC
     * landing when the ID is missing/undefined.
     */
    hydrateFcCycleFromRoute() {
      this.handleFCRouteParamChange(extractCycleIdFromRoute(this.$route));
    },
    handleFCRouteParamChange(cycleId) {
      if (!this.$route.path.includes('/financialclose/')) return;
      // Setup masters (e.g. tasklist/:id) use :id for template ids — never treat as cycle.
      if ((this.$route.path || '').includes('/financialclose/setup/')) return;
      // Immediate route watchers run before getdetails; wait until org is known.
      if (!this.$store.state.noauth && (!this.profileDetailsReady || !this.$store.state.client)) {
        return;
      }
      if (!cycleId || cycleId === 'undefined') {
        if (this.$route.path.includes(FC_ROUTES.PROJECT_PREFIX)) {
          console.log(`[base.vue]: Detected undefined project ID in route, redirecting to FC landing`);
          this.navigateToFCLanding();
        }
        return;
      }
      // Hydrate cycle side-nav items on refresh / deep-link (replaces FinancialCloseMenu init)
      this.$store.dispatch('fetchAndSetCycleFromRoute', { routePath: this.$route.path })
        .catch((err) => {
          console.error('[base.vue]: fetchAndSetCycleFromRoute error', err);
        });
    },
    /**
     * Hard navigate for client switches so we don't patch the old product page.
     * Same path / same href uses router.replace (no full reload). Full assign
     * only when the product landing path actually changes.
     */
    hardNavigate(path, query = {}, { rehydrate = false } = {}) {
      if (!path) return;
      const resolved = this.$router.resolve({ path, query });
      console.log('[base.vue]: hardNavigate', resolved.href);
      if (hrefMatchesCurrent(resolved.href, window.location)) {
        if (rehydrate) this.rehydrateAfterClientChange();
        return;
      }
      const currentPath = normalizeRoutePath(this.$route.path);
      const nextPath = normalizeRoutePath(path);
      if (currentPath === nextPath) {
        this.$router.replace({
          path,
          query,
          hash: this.$route.hash,
        }).catch(() => { });
        if (rehydrate) this.rehydrateAfterClientChange();
        return;
      }
      this.persistCycleListLiteHandoff();
      window.location.assign(resolved.href);
    },

    /**
     * One-shot lite list for the next page load. Written only on the client-switch
     * full reload, immediately before window.location.assign.
     */
    persistCycleListLiteHandoff() {
      const clientId = this.$store.state.client;
      const fc = this.$store.state.m_financialclose;
      if (!clientId || !fc) return;
      if (String(fc.cyclesForSwitcherClient || '') !== String(clientId)) return;
      const cycles = fc.cyclesForSwitcher;
      if (!Array.isArray(cycles) || cycles.length === 0) return;
      writeCycleListLiteHandoff(window.sessionStorage, clientId, cycles);
    },

    rehydrateAfterClientChange() {
      this.$store.commit('clearCyclesForSwitcher');
      this.$store.dispatch('tasks/resetTasklistForClientSwitch');
      this.loading--;
      if (this.$store.state.loading > 0) {
        this.$store.commit('removeLoading');
      }
      this.getDetails({ preferClientId: this.selectedclient });
    },

    initSelectedClientFromRoute() {
      if (isPbcRequesteeRoute(this.$route?.path)) {
        this.selectedclient = String(
          this.$route.params.client
          || this.$route.query.cid
          || this.$store.state.client
          || '',
        );
        return;
      }
      const list = this.$store.state.clientlist || [];
      const urlCid = this.$route.query.cid;
      if (urlCid && isClientInList(urlCid, list)) {
        this.selectedclient = String(urlCid);
        return;
      }
      const fallback = String(
        this.$store.state.client
        || (list[0] && list[0]._id)
        || '',
      );
      if (fallback) this.selectedclient = fallback;
      if (urlCid && list.length && !isClientInList(urlCid, list) && fallback) {
        this.syncClientInUrl(fallback);
      }
    },

    /**
     * Best homepage for a client from profile flags.
     * Prefer Commentary/VA (and Bot/Flux) over FC when the client has multiple
     * products — otherwise Gen AI / Commentary clients with leftover FC access
     * stay stuck on financialclose when switching orgs.
     */
    getBestProductRouteForClient(clientId) {
      const id = String(clientId || '');
      const clientData = this.$store.state.clientlist?.find(c => String(c._id) === id);
      if (!clientData) return constants.ROUTE_PATHS.ROOT;

      if (clientData.hasVarianceAnalysisAccess) {
        return clientData.varianceAnalysisHomepage || constants.ROUTE_PATHS.VA_ACTUAL_ANALYSIS;
      }
      if (clientData.hasBotAccess) {
        return clientData.botHomepage || constants.ROUTE_PATHS.BOT_PROJECT;
      }
      if (clientData.hasFluxAccess) {
        return clientData.fluxHomepage || constants.ROUTE_PATHS.FLUX_PROJECT;
      }
      if (clientData.hasFinancialCloseAccess) {
        return clientData.financialCloseHomepage || '/financialclose/home';
      }
      return constants.ROUTE_PATHS.ROOT;
    },

    /**
     * Synchronous landing URL for non-FC organisation switches.
     */
    getClientSwitchLanding(clientId) {
      const id = String(clientId || '');
      const path = this.getBestProductRouteForClient(id) || constants.ROUTE_PATHS.ROOT;
      return { path, query: { cid: id } };
    },

    /** FC-primary client: land on most recent open cycle tasklist after switch. */
    shouldResolveFcCycleLanding(clientId) {
      const id = String(clientId || '');
      const clientData = this.$store.state.clientlist?.find((c) => String(c._id) === id);
      if (!clientData?.hasFinancialCloseAccess) return false;
      const bestPath = this.getBestProductRouteForClient(id);
      return String(bestPath).includes(`/${constants.PRODUCT_KEYS.FINANCIAL_CLOSE}`);
    },

    async resolveFcClientSwitchLanding(clientId) {
      const id = String(clientId || '');
      try {
        const cycle = await this.fetchFCLandingCycle();
        if (cycle?._id) {
          this.$store.commit('addItemToCycleList', cycle);
          return { path: FC_ROUTES.CHECKLIST(cycle._id), query: { cid: id } };
        }
      } catch (err) {
        console.warn('[base.vue]: FC cycle landing fetch failed during client switch', err);
      }
      return { path: FC_ROUTES.HOME, query: { cid: id } };
    },

    /**
     * Navigate after store/localStorage are updated for the new client.
     * FC clients: fetch most recent open cycle (with progress bar already shown).
     * Other products: navigate immediately.
     */
    performClientSwitch(nextId, previousClient) {
      const requestId = ++this.clientSwitchRequestId;
      const id = String(nextId || '');

      if (!this.shouldResolveFcCycleLanding(id)) {
        const landing = this.getClientSwitchLanding(id);
        console.log('[base.vue]: client switch landing', previousClient, '→', id, landing);
        this.hardNavigate(landing.path, landing.query, { rehydrate: true });
        return;
      }

      this.resolveFcClientSwitchLanding(id)
        .then((landing) => {
          if (requestId !== this.clientSwitchRequestId) return;
          console.log('[base.vue]: FC client switch landing', previousClient, '→', id, landing);
          this.hardNavigate(landing.path, landing.query, { rehydrate: true });
        })
        .catch((err) => {
          if (requestId !== this.clientSwitchRequestId) return;
          console.error('[base.vue]: FC client switch landing error', err);
          this.hardNavigate(FC_ROUTES.HOME, { cid: id }, { rehydrate: true });
        });
    },

    // ─── End Financial Close helpers ────────────────────────────────

    // ─── Client URL sync & Product Access ──────────────────────────────

    /**
     * Sync cid into the URL without a full page load when the path is unchanged.
     */
    syncClientInUrl(clientId) {
      if (!clientId) return;
      if (isPbcRequesteeRoute(this.$route?.path)) return;
      if (String(this.$route.query.cid || '') === String(clientId)) return;

      const query = { ...this.$route.query, cid: clientId };
      // Admin console: sync cid in-router — full reload leaves the global loader stuck
      if (this.isAdminConsolePath()) {
        this.$router.replace({
          path: this.$route.path,
          query,
          hash: this.$route.hash,
        }).catch((err) => {
          if (err?.name !== 'NavigationDuplicated') {
            console.error('[base.vue]: syncClientInUrl admin console failed', err);
          }
        });
        return;
      }

      const resolved = this.$router.resolve({
        path: this.$route.path,
        query,
        hash: this.$route.hash
      });
      console.log('[base.vue]: syncClientInUrl', clientId, resolved.href);
      if (hrefMatchesCurrent(resolved.href, window.location)) return;
      this.$router.replace({
        path: this.$route.path,
        query,
        hash: this.$route.hash,
      }).catch(() => { });
    },

    /**
     * Verify user has subscription and permission to access a route.
     * Called on route navigation when cid remains the same.
     * NOTE: When cid changes, this DOES NOT run — preemptive checks
     * in selectedclient watcher handle client-switch redirects.
     */
    isAdminConsolePath(route = this.$route) {
      const path = route?.path || '';
      return path.startsWith('/platform/console') || route?.matched?.some((r) => r.meta?.adminConsole);
    },

    routeRequiresManager(route = this.$route) {
      return Boolean(route?.matched?.some((record) => record.meta?.requiresManager));
    },

    waitForCycleSwitcherIdle() {
      const fc = this.$store.state.m_financialclose;
      if (!fc || !fc.cyclesForSwitcherLoading) return Promise.resolve();
      return new Promise((resolve) => {
        let unwatch = () => {};
        let settled = false;
        const finish = () => {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          unwatch();
          resolve();
        };
        const timer = setTimeout(finish, 8000);
        unwatch = this.$store.watch(
          (state) => Boolean(state.m_financialclose && state.m_financialclose.cyclesForSwitcherLoading),
          (loading) => {
            if (!loading) finish();
          },
        );
      });
    },

    async ensureCyclesForSwitcher() {
      const cycles = () => this.$store.state.m_financialclose;
      if (!cycles()) return;
      const hasCycles = () => Array.isArray(cycles().cyclesForSwitcher) && cycles().cyclesForSwitcher.length > 0;
      if (hasCycles()) return;
      if (cycles().cyclesForSwitcherLoading) {
        await this.waitForCycleSwitcherIdle();
        if (hasCycles()) return;
      }
      await this.$store.dispatch('fetchCyclesForSwitcher');
      if (cycles() && cycles().cyclesForSwitcherLoading) {
        await this.waitForCycleSwitcherIdle();
      }
    },

    /**
     * Admin Console is listed only for cycle managers. Direct URLs use the same check
     * once the session and cycle list are available.
     */
    async userMayOpenAdminConsole() {
      const userId = this.$store.state.user?.id || this.$store.state.user?._id;
      if (!userId) return !this.profileDetailsReady;
      if (isAppSwitcherManagerUser(this.$store)) return true;
      try {
        await this.ensureCyclesForSwitcher();
      } catch (err) {
        console.error('[base.vue]: Admin Console manager lookup failed', err);
      }
      return isAppSwitcherManagerUser(this.$store);
    },

    async denyAdminConsoleAccess() {
      console.log('[base.vue]: Admin Console denied, redirecting');
      const applist = this.applist || [];
      if (applist.find((item) => item.name === constants.PRODUCT_KEYS.FINANCIAL_CLOSE)) {
        await this.navigateToFCLanding();
        return;
      }
      if (applist.find((item) => item.name === constants.PRODUCT_KEYS.VARIANCE_ANALYSIS)) {
        this.$nova.gotoLink({ path: constants.ROUTE_PATHS.VA_ACTUAL_ANALYSIS });
        return;
      }
      this.$nova.gotoLink({ path: applist[0]?.link || constants.ROUTE_PATHS.ROOT });
    },

    hideAppSideNav(route = this.$route) {
      return this.isAdminConsolePath(route) || route?.matched?.some((r) => r.meta?.hideSideNav);
    },

    accrualsSurfaceOpen(route = this.$route) {
      return isAccrualsSurfacePath(route?.path);
    },

    redirectAwayFromAccruals(route = this.$route) {
      if (!this.$store.state.accrualsBotFlagReady) return false;
      if (this.$store.state.accrualsbotEnabled === true) return false;
      if (!this.accrualsSurfaceOpen(route)) return false;
      console.log('[base.vue]: Accruals is disabled for this client, redirecting');
      if ((route?.path || '').includes('/financialclose/')) {
        this.navigateToFCLanding();
        return true;
      }
      this.$nova.gotoLink({ path: constants.ROUTE_PATHS.ROOT });
      return true;
    },

    async checkSubscriptionPermission(to, from) {
      if (this.redirectAwayFromAccruals(to || this.$route)) return;
      if (this.routeRequiresManager(to)) {
        const allowed = await this.userMayOpenAdminConsole();
        if (!allowed) {
          console.log(`[base.vue]: Admin Console denied to ${to.path}, redirecting...`);
          await this.denyAdminConsoleAccess();
          return;
        }
      }

      if (this.isAdminConsolePath(to)) {
        this.setCustomMenu();
        this.setMenu(to.path);
        return;
      }

      // Only check when navigating within the same client (cid unchanged)
      if (from?.query?.cid !== to?.query?.cid) return;

      const requiredsubs = to.meta.subscription || [];
      const avaliablesubs = this.$store.state.subscriptions;

      // Check subscription
      const hasSubscription = requiredsubs.length === 0 || requiredsubs.some(sub =>
        avaliablesubs[sub] || avaliablesubs[sub?.toUpperCase()]
      );

      // Check permission
      const hasPermission = !to.meta.right || this.$nova.hasRight(to.meta.right, to.meta.action);

      // Allow if: (has both sub & permission) OR route allows all OR subscriptions are disabled
      if ((hasSubscription && hasPermission) || to.meta.allow || process.env.VUE_APP_IGNORE_SUBSCRIPTIONS === '1') {
        this.setCustomMenu();
        this.setMenu(to.path);
        return;
      }

      // Access denied — redirect to an available product
      console.log(`[base.vue]: Access denied to ${to.path}, redirecting...`);

      // Build redirect route data
      const routeData = {
        path: to.path,
        query: { ...to.query },
        hash: to.hash,
      };

      // Determine redirect destination based on available products
      if (this.applist.find(item => item.name === constants.PRODUCT_KEYS.FINANCIAL_CLOSE)) {
        if (!hasSubscription) {
          // console.log("Redirecting to FC landing page due to missing subscription for current route");
          await this.navigateToFCLanding();
        } else {
          // Has subscription but lacks permission — go back
          this.$router.go(-1);
        }
      } else if (this.applist.find(item => item.name === constants.PRODUCT_KEYS.VARIANCE_ANALYSIS)) {
        routeData.path = constants.ROUTE_PATHS.VA_ACTUAL_ANALYSIS;
        this.$router.push(routeData).catch(() => { });
      } else {
        // Fallback to first available product
        routeData.path = this.applist?.[0]?.link || constants.ROUTE_PATHS.ROOT;
        this.$router.push(routeData).catch(() => { });
      }

      this.setCustomMenu();
      this.setMenu(to.path);
    },
    findIcon(name) {
      let iconname = this.$store.state.menu.filter((item) => {
        if (item.title === name)
          return item.icon
      })
      return iconname[0].icon
    },
    findlist() {
      const result = {};
      let currentKey = null;
      this.$store.state.menu.forEach(obj => {
        if (obj.header) {
          currentKey = obj.title;
          result[currentKey] = [];
        } else if (currentKey) {
          result[currentKey].push(obj);
        }
      });
      this.newMenuList = result;
    },

    resolveProfileEmail(user = this.$store.state.user) {
      return user?.email || user?.contactemail || '';
    },
    syncProfileFormFromStore() {
      const user = this.$store.state.user || {};
      this.profileImage = user.profile || user.profile_url || null;
      this.userName = user.name || '';
      this.userContact = user.contactno || '';
      this.userDesgination = user.designation || '';
      this.userEmail = this.resolveProfileEmail(user);
    },
    applyProfileUpdateToStore(updatedUser = {}) {
      const email = updatedUser.contactemail || updatedUser.email || this.resolveProfileEmail();
      this.$store.commit('setUser', {
        name: updatedUser.name || this.$store.state.user.name || '',
        email,
        contactno: updatedUser.contactno || this.$store.state.user.contactno || '',
        countrycode: updatedUser.countrycode || this.$store.state.user.countrycode || '',
        designation: updatedUser.designation || this.$store.state.user.designation || '',
        activestatus: updatedUser.activestatus || this.$store.state.user.activestatus || '',
        profile: updatedUser.profile_url || updatedUser.profile || this.$store.state.user.profile || '',
        id: updatedUser._id || this.$store.state.user.id || '',
      });
      this.syncProfileFormFromStore();
    },
    async updateProfile(file = null) {
      const now = new Date();
      const epochTime = now.getTime();
      if (!this.$store.state.noauth) {
        let profilePath = '';
        let details = {
          username: this.userName || this.$store.state.user.name || "",
          contactno: this.userContact || this.$store.state.user.contactno || "",
          countrycode: this.$store.state.user.countrycode || "",
          email: this.resolveProfileEmail(),
          designation: this.userDesgination || this.$store.state.user.designation || "",
          activestatus: this.userStatus.name || this.$store.state.user.activestatus || "",
        };
        if (file) {
          profilePath = await this.$nova.uploadFile(this.axios, file);
          details = {
            ...details,
            profile_url: profilePath.data.data[0].path,
            upload_id: profilePath.data.data[0]._id,
            profile_url_expiration: epochTime,
          }
        }

        this.axios.post(constants.API_URLS.PROFILE_UPDATE, { data: [details] }).then(dt => {
          const updatedUser = dt.data.data?.[0] || {};
          if (dt.data.status == 'success') {
            this.$store.commit("sbSuccess", "Profile Updated successfully")
            this.applyProfileUpdateToStore(updatedUser);
          }
          else {
            this.$store.commit("sbError", dt.data.message || "Unknown error!");
          }
          if (updatedUser.profile_url) {
            this.profileImage = updatedUser.profile_url;
          }
          this.editProfileDrawer = false
          this.editProfileSetting = false
        });
      }
    },
    /**
     * Information Request email links land on /pbc/requestee/* in noauth mode
     * (no profile client list). Hydrate the entity chip from getlocation.
     * Ask Noa visibility stays on the client `chatbotEnabled` flag from getlocation
     * (via fetchLocation); requestee routes hide the button in showNonFbcNavActionsChatbot.
     */
    async hydrateRequesteeNavContext() {
      if (!isPbcRequesteeRoute(this.$route?.path)) return;

      const clientId = String(
        this.$route.params.client
        || this.$route.query.cid
        || this.$store.state.client
        || ''
      );
      if (!clientId) {
        console.log('[base.vue]: Requestee route missing client id');
        return;
      }

      console.log('[base.vue]: Hydrating requestee nav context', clientId);
      this.$store.commit('setClient', clientId);
      if (String(this.selectedclient || '') !== clientId) {
        this.selectedclient = clientId;
      }
      this.fetchLabelsData();

      const existing = (this.$store.state.clientlist || []).find(
        (c) => String(c._id) === clientId && c.name
      );
      if (existing) return;

      // Preserve any already-loaded client list (authenticated users) and
      // only upsert the requestee entity — never replace the full list.
      const upsertClientIntoList = (entry) => {
        const nextClientList = Array.isArray(this.$store.state.clientlist)
          ? [...this.$store.state.clientlist]
          : [];
        const entryId = String(entry._id);
        const idx = nextClientList.findIndex((c) => String(c._id) === entryId);
        if (idx >= 0) {
          nextClientList.splice(idx, 1, { ...nextClientList[idx], ...entry });
        } else {
          nextClientList.push(entry);
        }
        this.$store.commit('setClientList', nextClientList);
      };

      try {
        const dt = await this.axios.post('/v2/client/getlocation');
        const clientDoc = (dt?.data?.data || [])[0] || null;
        if (clientDoc?._id) {
          upsertClientIntoList({
            _id: String(clientDoc._id),
            name: clientDoc.name || 'Client',
          });
          this.$store.commit('setClientDetails', clientDoc);
        } else {
          upsertClientIntoList({ _id: clientId, name: 'Client' });
        }
      } catch (err) {
        console.error('[base.vue]: requestee entity hydrate failed', err);
        upsertClientIntoList({ _id: clientId, name: 'Client' });
      }
    },

    async getLocationHeader() {
      await this.$store.dispatch('fetchLocation');
      this.redirectAwayFromAccruals(this.$route);
    },
    openFDSupport() {
      this.selectedItem = 'support';

      if (this.fdSupportWidget && this.$freshworks?.isEnabled) {
        const isNowOpen = this.$freshworks.toggle({
          name: this.userName,
          email: this.userEmail
        });

        this.chatWidgetInView = isNowOpen;

        if (isNowOpen) {
          this.$freshworks.onClose(() => {
            this.chatWidgetInView = false;
          });
        }
        return;
      }

      if (this.isFinancialCloseRoute && FC_ROUTES.SUPPORT) {
        this.$nova.gotoLink({
          path: FC_ROUTES.SUPPORT,
          query: this.selectedclient ? { cid: this.selectedclient } : undefined
        });
      }
    },

    onMainNavClientChange(clientId) {
      const nextId = clientId != null ? String(clientId) : '';
      if (!nextId || nextId === String(this.selectedclient || '')) return;
      console.log('[base.vue]: MainNav client-change', nextId);
      this.selectedclient = nextId;
    },

    onMainNavAppClick(app) {
      if (!app?.link) return;
      console.log('[base.vue]: MainNav app-click', app.name);
      this.$root.closeFloatingComponents?.();

      const isAdminConsole = String(app.link).includes('/platform/console');
      const path = app.link;
      const cid = this.$route.query.cid || this.$store.state.client;
      const query = { ...this.$route.query };
      if (cid) query.cid = String(cid);

      if (isAdminConsole) {
        this.clientload = true;
        if (this.$store.state.loading > 0) {
          this.$store.commit('removeLoading');
        }
      }

      try {
        if (isAdminConsole) {
          const resolved = this.$router.resolve({ path, query });
          const matched = resolved?.route?.matched || [];
          const hasAdminConsoleRoute = matched.some((record) => record.meta?.adminConsole);
          if (!hasAdminConsoleRoute) {
            console.error('[base.vue]: Admin Console route not registered', path, matched);
            return;
          }
        }

        this.$router.push({ path, query }).catch((err) => {
          if (err?.name !== 'NavigationDuplicated') {
            console.error('[base.vue]: MainNav app navigation failed', err);
          }
        });
      } catch (e) {
        console.error('[base.vue]: MainNav app navigation failed', e);
      }
    },

    openFloatingComponent(componentName) {
      // Generic method to open any floating component
      // Automatically closes other floating components
      if (this.floatingComponentOpen === componentName) {
        // Toggle off if clicking the same component
        this.floatingComponentOpen = null;
        this.selectedItem = null;
      } else {
        this.selectedItem = componentName;
        this.floatingComponentOpen = componentName;
      }
    },
    toggleChatbot() {
      this.syncChatbotContextFromRoute();
      this.openFloatingComponent('chatbot');
    },
    /**
     * Populate chatbot Vuex project/task (and role) from the active route
     * so DirectLine channelData.params include projectId / taskId.
     *
     * FBC-specific today: only Financial Close cycle/checklist/task routes are
     * resolved via extractChatbotContextFromRoute. Update this when more product
     * contexts (e.g. VA/Flux, PBC) are available so it can be made generic.
     */
    syncChatbotContextFromRoute() {
      const context = extractChatbotContextFromRoute(this.$route);
      if (!context) return;

      const role = this.$route.query?.userType
        || this.$store.state.tasklistUserType
        || this.$store.state.chatbot?.role
        || null;

      this.$store.dispatch('chatbot/setContextFromRoute', {
        projectId: context.projectId,
        taskId: context.taskId,
        role,
      });
    },
    closeChatbot() {
      if (this.floatingComponentOpen === 'chatbot') {
        this.floatingComponentOpen = null;
        if (this.selectedItem === 'chatbot') {
          this.selectedItem = null;
        }
      }
    },
    closeFloatingComponent(componentName) {
      // Generic method to close a specific floating component
      if (this.floatingComponentOpen === componentName) {
        this.floatingComponentOpen = null;
        if (this.selectedItem === componentName) {
          this.selectedItem = null;
        }
      }
    },
    closeFloatingComponents(context) {
      // Centralized method to close all floating/overlay components
      // Skip closing if the context is the component being opened
      if (!context || context !== this.floatingComponentOpen) {
        this.floatingComponentOpen = null;
        if (this.selectedItem && this.selectedItem !== context) {
          this.selectedItem = null;
        }
      }
    },
  },
  computed: {
    profileEmail() {
      return this.resolveProfileEmail(this.$store.state.user);
    },
    chatbotEnabled() {
      return this.$store.state.chatbotEnabled;
    },
    isFinancialCloseRoute() {
      return constants.menuContextPath(this.$route.path || '').includes(constants.PRODUCT_KEYS.FINANCIAL_CLOSE);
    },
    showManuals() {
      const product = this.manualsProduct;
      if (!product) return false;
      const manualsState = this.$store.state.m_manuals || {};
      return Boolean(manualsState.available)
        && manualsState.availableProduct === product
        && String(manualsState.availableClientId || '') === String(this.selectedclient || '');
    },
    manualsProduct() {
      return constants.resolveManualsProduct(constants.menuContextPath(this.$route.path || ''));
    },
    manualsAvailabilityKey() {
      return `${this.selectedclient || ''}:${this.manualsProduct || ''}`;
    },
    /** Keep Cycle Settings shell mounted when switching Team ↔ Threshold tabs */
    mainRouterViewKey() {
      const path = this.$route.path || '';
      if (path.startsWith('/platform/console')) return '/platform/console';
      const match = path.match(/^(.*?\/cycle-settings\/[^/]+)/);
      if (match) return match[1];
      const accrualsDataMatch = path.match(/^(\/financialclose\/automationaccruals\/[^/]+\/data)/);
      if (accrualsDataMatch) return accrualsDataMatch[1];
      const accrualsConfigMatch = path.match(/^(\/financialclose\/automationaccruals\/[^/]+\/configuration)/);
      if (accrualsConfigMatch) return accrualsConfigMatch[1];
      return this.$route.fullPath;
    },
    logoHomeRoute() {
      return this.getBestProductRouteForClient(this.selectedclient);
    },
    fbcNavContext() {
      return resolveFbcNavContext(constants.menuContextPath(this.$route.path || ''));
    },
    showSideNav() {
      if (this.hideAppSideNav()) return false;
      if (!this.isFinancialCloseRoute) return true;
      return this.fbcNavContext !== 'hidden';
    },
    /** Flush side nav + main join (no rounded corner gap); FBC + AppMenu shell */
    useFlushSideNavLayout() {
      if (this.hideAppSideNav()) return true;
      return this.isFinancialCloseRoute || this.showSideNav;
    },
    activeFbcCycleId() {
      if (constants.isManualsPath(this.$route.path)) {
        return extractCycleIdFromPath(constants.menuContextPath(this.$route.path));
      }
      return extractCycleIdFromRoute(this.$route);
    },
    canAccessFinancialCloseMasters() {
      const isFinancialCloseAdmin = this.$store.state.clientDetails?.isFinancialCloseAdmin;
      return typeof isFinancialCloseAdmin === 'boolean' ? isFinancialCloseAdmin : false;
    },
    showMainNavClientSwitcher() {
      const path = this.$route.path || '';
      const alwaysShowClientInInjector =
        path.startsWith('/pbc') || path.startsWith('/chatbot');
      const showClientsMeta = (this.$route.meta || {}).showclients !== false;
      return (showClientsMeta && this.showHeaderAction) || alwaysShowClientInInjector;
    },
    /** Whether non-FBC injector actions (Ask Noa, etc.) should render — extend with || as new actions are added */
    showNonFbcNavActions() {
      return this.showNonFbcNavActionsChatbot;
    },
    showNonFbcNavActionsChatbot() {
      // Ask Noa is driven by client.chatbotEnabled (getlocation → fetchLocation).
      // Requestee / IR email links: hide regardless of that flag — not applicable here.
      if (isPbcRequesteeRoute(this.$route.path)) return false;
      return this.chatbotEnabled;
    },
    showMainNavInjectorTrailing() {
      return this.showMainNavClientSwitcher || this.showNonFbcNavActions;
    },
  },
  watch: {
    // ─── FC route param watchers ──────────────────────────────────
    // These delegate to handleFCRouteParamChange in the FC helpers
    // section. They exist as watchers because Vue requires them here,
    // but the logic is consolidated in the methods above.
    '$route.params.id': {
      handler() {
        // Use extractCycleIdFromRoute so setup template :id is ignored.
        this.handleFCRouteParamChange(extractCycleIdFromRoute(this.$route));
      },
      immediate: true
    },
    '$route.params.projectId': {
      handler() {
        this.handleFCRouteParamChange(extractCycleIdFromRoute(this.$route));
      },
    },
    // ─── End FC route param watchers ──────────────────────────────
    profileImage() {
      this.profileImageError = false;
      this.profileImageMenuError = false;
    },
    editProfileDrawer(isOpen) {
      if (isOpen) this.syncProfileFormFromStore();
    },
    editProfileSetting(isOpen) {
      if (isOpen) this.syncProfileFormFromStore();
    },
    $route(to, from) {
      if (constants.isManualsPath(to?.path) && from?.path) {
        constants.rememberManualsReturnPath(from.path);
      } else if (constants.isManualsPath(from?.path) && !constants.isManualsPath(to?.path)) {
        constants.clearManualsReturnPath();
      }
      this.checkSubscriptionPermission(to, from);
      // Ask Noa (and other floating overlays) hide router-view; dismiss on real navigation
      if (from && to.fullPath !== from.fullPath) {
        this.closeFloatingComponents();
      }
      if (isPbcRequesteeRoute(to?.path)) {
        this.hydrateRequesteeNavContext();
      }
    },
    isFinancialCloseRoute: {
      immediate: true,
      handler(isFcRoute) {
        document.body.classList.toggle('fbc-main-nav', isFcRoute);
      }
    },
    fbcNavContext: {
      immediate: true,
      handler(ctx) {
        // Only apply FBC-specific mini defaults when inside Financial Close
        if (!this.isFinancialCloseRoute) return;
        if (ctx === 'fbc-cycle') {
          this.navminivarient = true;
        } else if (ctx === 'fbc-settings') {
          this.navminivarient = false;
        }
        document.body.classList.toggle('nav-mini', this.navminivarient);
        document.body.classList.toggle('nav-full', !this.navminivarient);
      }
    },
    manualsAvailabilityKey: {
      immediate: true,
      handler() {
        if (!this.$store.hasModule('m_manuals')) return;
        this.$store.dispatch('m_manuals/fetchAvailability', {
          product: this.manualsProduct,
        });
      }
    },
    selectedclient(d) {
      if (!d) return;
      const nextId = String(d);
      const previousClient = this.$store.state.client;
      const list = this.$store.state.clientlist || [];
      // Requestees cannot switch organisations via the injector chip —
      // pin selection back to the hydrated store client (do not setClient).
      if (isPbcRequesteeRoute(this.$route?.path)) {
        if (nextId === String(previousClient || '')) return;
        this.selectedclient = String(previousClient || nextId);
        return;
      }
      if (list.length && !isClientInList(nextId, list)) {
        const fallback = String(previousClient || (list[0] && list[0]._id) || '');
        if (fallback && fallback !== nextId) {
          this.selectedclient = fallback;
        } else if (fallback) {
          this.syncClientInUrl(fallback);
        }
        return;
      }
      if (!list.length) {
        if (nextId === String(previousClient || '')) {
          this.syncClientInUrl(nextId);
        }
        return;
      }
      // Store-initiated sync: client already matches, just ensure cid is in URL.
      if (nextId === String(previousClient || '')) {
        this.syncClientInUrl(nextId);
        return;
      }
      this.$store.commit('addLoading');
      this.loading++;
      try {
        this.$store.commit('setClient', nextId);
        const nextClientDetails =
          this.$store.state.clientlist?.find((c) => String(c._id) === nextId);
        if (nextClientDetails) {
          this.$store.commit('setClientDetails', nextClientDetails);
        }
        try {
          localStorage.setItem(constants.STORAGE_KEYS.ENTITY, nextId);
        } catch (e) { /* ignore storage errors */ }

        this.fetchLabelsData();
        this.performClientSwitch(nextId, previousClient);
      } catch (err) {
        console.error('[base.vue]: selectedclient switch error', err);
        this.loading--;
        this.$store.commit('removeLoading');
        if (this.shouldResolveFcCycleLanding(nextId)) {
          this.hardNavigate(FC_ROUTES.HOME, { cid: nextId }, { rehydrate: true });
        } else {
          const landing = this.getClientSwitchLanding(nextId);
          this.hardNavigate(landing.path, landing.query, { rehydrate: true });
        }
      }
    },
    // Syncs the client dropdown selection from the store.
    // Route/URL sync is handled by the selectedclient watcher above so that
    // FC project pages can navigate to the correct cycle instead of blindly
    // updating the cid on a stale project URL.
    '$store.state.client': function (d) {
      this.selectedclient = d != null ? String(d) : '';
    },
    '$store.state.refreshclient': function (d) {
      if (d) this.getDetails();
    },
    '$store.state.containerheight': function (d) {
      this.containerHeight = d + "px";
    },
    '$store.state.navigation': function (d) {
      this.showNavgation = d;
    },
    '$store.state.headeraction': function (d) {
      this.showHeaderAction = d;
    },
    '$store.state.custommenu': function () {
      this.setMenu(this.$route.path);
    },
    '$store.state.permission': function () {
      this.setMenu(this.$route.path);
    },
    '$store.state.mininavbar': function () {
      this.navminivarient = this.$store.state.mininavbar;
      localStorage.setItem("navminivarient", this.navminivarient);
    },
    '$store.state.menu': function () {
      this.findlist()
    },
    navminivarient(val) {
      document.body.classList.toggle('nav-mini', val);
      document.body.classList.toggle('nav-full', !val);
    }
  },
};
</script>

<style scoped>
/* Retained only truly component-specific overrides (currently none). Navigation
   related styles were migrated & tokenized inside `_globals.scss`. */
.nav-img-icon {
  display: inline-block;
  vertical-align: middle;
  object-fit: contain;
}

:deep(.nav-img-icon) {
  filter: brightness(100) saturate(0%);
}

:deep(.logout-icon:hover) {
  /* Hex: #FF4D4D */
  filter: invert(44%) sepia(74%) saturate(2335%) hue-rotate(330deg) brightness(100%) contrast(101%);
}

/* :deep(.v-alert__wrapper) { display: ruby;} */
:deep(.v-alert__icon) {
  align-self: auto;
}

/* Floating component full page styles */
.floating-component-page {
  display: flex;
  flex-direction: column;
  background-color: #fafafa;
  z-index: 1;
}

.floating-component-content {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.floating-component-content :deep(.chatbot-container) {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
